// extracted by mini-css-extract-plugin
export var deleteModal = "_ib-0";